import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

export const loadRegions: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { regionApi },
) =>
  action$.pipe(
    ofType(actions.REGIONS_ACTIONS.REQUESTED),
    switchMap(() => {
      const { id } = store.value.auth.user;
      return regionApi.getManagerRegions(id).pipe(
        switchMap(({ regions }) => of(actions.regionsSucceeded(regions))),
        catchError(error => of(actions.regionsFailed(error))),
      );
    }),
  );



// WEBPACK FOOTER //
// ./src/scenes/Regions/services/epics/loadRegions.ts